import script from "./TvPersonalisation.vue?vue&type=script&setup=true&lang=js"
export * from "./TvPersonalisation.vue?vue&type=script&setup=true&lang=js"

import "./TvPersonalisation.vue?vue&type=style&index=0&id=075fc772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-075fc772"]])

export default __exports__